<template>
  <!-- Section Constructing Ethos Hero Start -->
  <section class="sec_handwoven_hero">
    <h2 class="card_heading_b" v-html="sanitizeHtml(shopifyData.preHeading)" />
    <div class="container">
      <div class="main_contenet">
        <h2 class="sec_heading" v-html="sanitizeHtml(shopifyData.secHeading)" />
        <h4
          class="card_heading_b sec_inner_heading"
          v-html="sanitizeHtml(shopifyData.subHeading)"
        />
        <p
          v-for="(value, key) in shopifyData.paragraphData"
          :key="key"
          class="body_text"
          v-html="sanitizeHtml(value.para)"
        />
      </div>
    </div>
    <div class="sec_img">
      <img
        v-lazy="shopifyData.imgUrl.src"
        class="w-100"
        :src-placeholder="shopifyData.imgUrl.placeholder"
        :alt="shopifyData.imgUrl.alt || 'Handwoven Silks Hero Image'"
        loading="lazy"
        aria-hidden="true"
        aria-label="Handwoven Silks Hero Image"
        width=""
        height=""
      />
    </div>
    <p class="subtitle" v-html="sanitizeHtml(shopifyData.afterImageText)" />
  </section>
  <!-- Constructing Ethos Hero Start -->
</template>

<script>
import { sanitizeHtml } from '@/sanitizeContent.js';

export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  methods: {
    sanitizeHtml,
  },
};
</script>

<style scoped>
.sec_handwoven_hero {
  padding-top: 60px;
  position: relative;
}
.sec_handwoven_hero::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  height: calc(100% - 30px);
  width: 100%;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #e9e7e3 100%);
  z-index: -1;
}
.card_heading_b {
  margin-bottom: 72px;
  text-align: center;
  text-transform: initial;
}
.card_heading_b.sec_inner_heading {
  margin: 14px 0;
  text-align: start;
}
.subtitle {
  margin: 6px 0 0 18px;
}

.sec_video iframe {
  width: 100%;
  height: 715px;
}
.sec_heading {
  line-height: 44px;
}
.main_contenet {
  max-width: 716px;
  margin: 0 auto 83px auto;
  width: 100%;
}

.sec_content {
  display: grid;
  grid-template-columns: 28% 64%;
  align-items: center;
  margin-top: 34px;
  gap: 30px;
}

.body_text {
  line-height: 19px;
  margin-bottom: 20px;
}
.body_text:last-child {
  margin-bottom: 0px;
}
/* Responsive Css Code */
@media screen and (max-width: 991px) {
  .sec_handwoven_hero {
    padding-top: 44px;
  }
  .main_contenet {
    padding: 0 20px;
    margin-bottom: 35px;
  }
  .card_heading_b {
    margin-bottom: 40px;
  }
}

@media screen and (max-width: 767px) {
  .main_contenet {
    margin-bottom: 25px;
  }
  .subtitle {
    margin: 6px 0 0 10px;
  }
}
</style>
